import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { URLsConfig } from '../URLsConfig';
import { DecisionModel } from '../models/DecisionModel';
import { CancerTreatmentModel } from '../models/CancerTreatmentModel';



@Injectable()
export class CancerTreatmentService {
    constructor(private http: HttpClient, public urlsconfig: URLsConfig) {
    }

    public getCancerTreatmentPatient(PatientCode: string) {
      let params = new HttpParams();
      params = params.append("PatientCode", PatientCode);
      const options = {
          params: params
      };
      return this.http.get<CancerTreatmentModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/CancerTreatment/GetCancerTreatment_Patient', options);
    }
    public getCancerTreatmentPatientChemo(PatientCode: string,trtype:string) {
      let params = new HttpParams();
      params = params.append("PatientCode", PatientCode);
      params = params.append("TrType", trtype);
      const options = {
          params: params
      };
      return this.http.get<CancerTreatmentModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/CancerTreatment/GetCancerTreatment_PatientChemo', options);
    }

    public getCancerTreatment(PatientCode: string,TrDate:string,TrType :string ) {
      let params = new HttpParams();
      params = params.append("TrDate", TrDate);
      params = params.append("PatientCode", PatientCode);
      params = params.append("TrType", TrType);

      const options = {
          params: params
      };
      return this.http.get<CancerTreatmentModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/CancerTreatment/GetCancerTreatment', options);
    }
    public AddCancerTreatment(Decision: CancerTreatmentModel) {
            return this.http.post<CancerTreatmentModel>(this.urlsconfig.WebAPIURL_Test + 'api/CancerTreatment/AddCancerTreatment', Decision);
    }
    public deleteCancerTreatment(TrDate:string ,PatientCode: string,TrType :string, TrKindid :string) {
      let params = new HttpParams();

      params = params.append("TrDate", TrDate);
      params = params.append("PatientCode", PatientCode);
      params = params.append("TrType", TrType);
      params = params.append("TrKindId", TrKindid);
      const options = {
          params: params
      };
      return this.http.get<CancerTreatmentModel>(this.urlsconfig.WebAPIURL_Test + 'api/CancerTreatment/DelCancerTreatment', options);
    }
}
